import request from '@/utils/request'
import requestJson from "@/utils/requestJson"

// 预采购单相关接口
export function preOrderBuyGetList(data) {
  return request({
    url: '/admin/pre_order_buy/getList',
    method: 'get',
    params: data
  })
}


export function preOrderBuyDel(data) {
  return request({
    url: '/admin/pre_order_buy/del',
    method: 'get',
    params: data
  })
}
// 可选商品列表
export function preOrderBuyListGetList(data) {
  return request({
    url: '/admin/pre_order_buy_list/getlist',
    method: 'get',
    params: data
  })
}

// 新增预采购单
export function preOrderBuyAdd(data) {
  return requestJson({
    url: '/admin/pre_order_buy/add',
    method: 'post',
    data
  })
}

// 获预采购单详情
export function preOrderBuyGetOne(data) {
  return requestJson({
    url: '/admin/pre_order_buy/getOne',
    method: 'get',
    params: data
  })
}

// 修改预采购单
export function preOrderBuyUp(data) {
  return requestJson({
    url: '/admin/pre_order_buy/up',
    method: 'post',
    data
  })
}

// 修改预采购单状态
export function preOrderBuyStatusUp(data) {
  return request({
    url: '/admin/pre_order_buy/upRemark',
    method: 'post',
    data
  })
}

// 撤回预采购订单
export function preOrderBuyLock(data) {
  return request({
    url: '/admin/pre_order_buy/lock',
    method: 'get',
    params: data
  })
}
// 预采购单商品数据源
export function stockItemGetList(data) {
  return request({
    url: '/admin/stock_item/getlist',
    method: 'get',
    params: data
  })
}

// 获取当前商户下所有账户
export function companyAccountGetList(data) {
  return request({
    url: '/admin/company_account/getlist',
    method: 'get',
    params: data
  })
}

// 获取用户授权可用使用的公司资金账户
export function userPermissionCompanyAccountGetList(data) {
  return request({
    url: '/admin/user_finance_permission/getlist',
    method: 'get',
    params: data
  })
}

// 获取当前门店下所有外卖收款账户
export function companyWmAccountGetList(data) {
  return request({
    url: '/admin/company_account/getWmList',
    method: 'get',
    params: data
  })
}

// 更新已选列表
export function preOrderBuyListUp(data) {
  return request({
    url: '/admin/pre_order_buy_list/up',
    method: 'post',
    data
  })
}


// 扫码接口
export function searchCode(data) {
  return request({
    url: '/admin/pre_order_buy_list/search_code',
    method: 'post',
    data
  })
}


// 采购单 新增
export function orderBuyAdd(data) {
  return requestJson({
    url: '/admin/order_buy/add',
    method: 'post',
    data
  })
}
// 采购单修改
export function orderBuyUp(data) {
  return requestJson({
    url: '/admin/order_buy/up',
    method: 'post',
    data
  })
}
// 采购单删除
export function orderBuyDel(data) {
  return request({
    url: '/admin/order_buy/del',
    method: 'get',
    params: data
  })
}
// 采购单列表
export function orderBuyGetList(data) {
  return request({
    url: '/admin/order_buy/getList',
    method: 'get',
    params: data
  })
}
// 采购单明细

export function orderBuyGetOne(data) {
  return request({
    url: '/admin/order_buy/getOne',
    method: 'get',
    params: data
  })
}


// 撤回
export function orderBuyUnDo(data) {
  return request({
    url: '/admin/order_buy/unDo',
    method: 'get',
    params: data
  })
}

// 依据表单号撤回
export function orderBuyUnDoFormSn(data) {
  return request({
    url: '/admin/order_buy/unDoFormSn',
    method: 'get',
    params: data
  })
}


// 调货单
export function orderMoveGetlist(data) {
  return request({
    url: '/admin/order_move/getlist',
    method: 'get',
    params: data
  })
}


// 撤销
export function orderMoveCancel(data) {
  return request({
    url: '/admin/order_move/cancel',
    method: 'get',
    params: data
  })
}

// 审核通过
export function orderMoveApproved(data) {
  return request({
    url: '/admin/order_move/Approved',
    method: 'get',
    params: data
  })
}

// 删除调货单
export function orderMoveDel(data) {
  return request({
    url: '/admin/order_move/del',
    method: 'get',
    params: data
  })
}

// 调货单获取产品列表
export function getShopStocks(data) {
  return request({
    url: '/admin/order_move/getShopStocks',
    method: 'get',
    params: data
  })
}

// 新增调货单
export function orderMoveAdd(data) {
  return requestJson({
    url: '/admin/order_move/add',
    method: 'post',
    data
  })
}

// 修改调货单
export function orderMoveUp(data) {
  return requestJson({
    url: '/admin/order_move/up',
    method: 'post',
    data
  })
}

// 调货明细
export function orderMoveDetail(data) {
  return request({
    url: '/admin/order_move/detail',
    method: 'get',
    params: data
  })
}
// 确认发货
export function orderMoveShipped(data) {
  return request({
    url: '/admin/order_move/Shipped',
    method: 'get',
    params: data
  })
}
// 确认到货
export function orderMoveReceived(data) {
  return request({
    url: '/admin/order_move/Received',
    method: 'get',
    params: data
  })
}


export function shouldGetDoGet(data) {
  return requestJson({
    url: '/admin/should_get/doGet',
    method: 'post',
    data
  })
}

export function shouldPayDoPay(data) {
  return requestJson({
    url: '/admin/should_pay/doPay',
    method: 'post',
    data
  })
}

// 采购订单统计
export function getOrderAllInfo(data) {
  return request({
    url: '/admin/order_buy/getOrderAllInfo',
    method: 'get',
    params: data
  })
}

export function orderBuyaddOrderMoney(data) {
  return request({
    url: '/admin/order_buy/add_order_money',
    method: 'post',
    data
  })
}

export function orderSellAddOrderMoney(data) {
  return request({
    url: '/admin/order_sell/add_order_money',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/purchasing.js